module.exports = __webpack_public_path__ + "static/media/0105.16072001.png";